import { Component, Input } from '@angular/core';

@Component({
    selector: 'al-secondary-windows',
    template: `<a href="javascript:void(0);" (click)="openSecondaryWindow();">{{label}}</a>`
})

export class AlSecondaryWindowsComponent {

    // Url to redirect
    @Input() url: string = '';

    // link label
    @Input() label: string;

    // window name
    @Input() windowName: string = '';

    // set width of secondary window
    @Input() width: number = 800;

    // set height of secondary window
    @Input() height: number = 400;

    // set titlebar of secondary window
    @Input() titlebar: boolean = true;

    // set resizable of secondary window
    @Input() resizable: boolean = true;

    // set scrollbars of secondary window
    @Input() scrollbars: boolean = true;

    // set fullscreen for seconday window
    @Input() fullscreen: boolean = false;

    /**
     * open/create secondary window with dynamic url and specified width and height
     *
     * @method openSecondaryWindow
     *
     */
    openSecondaryWindow() {
        window.open(this.url, this.windowName, `width=${this.width},height=${this.height},titlebar=${this.titlebar},resizable=${this.resizable},scrollbars=${this.scrollbars},fullscreen=${this.fullscreen}`);
    }
}
